import React, { useState } from "react";
import MChip from "@/components/ui/atoms/MChip";
import MPill from "@/components/ui/atoms/MPill";
import { IconCheck } from "@tabler/icons-react";

const ChipDemo: React.FC = () => {
  const [selected, setSelected] = useState(false);
  const [selected2, setSelected2] = useState(true);

  return (
    <div style={{ padding: 32 }}>
      <h2>Chip Demo</h2>
      <br/>
      <div style={{ display: "flex", gap: 16 }}>
        <MChip
          text="Unselected Chip"
          selected={false}
          onClick={() => setSelected((s) => !s)}
        />
        <MChip
          text="Selected Chip"
          selected={true}
          onClick={() => setSelected2((s) => !s)}
        />
        <MChip
          text="No Icon"
          rightIcon={false}
        />
        <MChip
          text="Custom Icon"
          rightIcon={<IconCheck />}
        />
        <MChip
          text="Disabled"
          disabled
        />
      </div>
      <br />
      <h3>MPill Demo</h3>
      <div style={{ display: 'flex', gap: 24 }}>
        <MPill icon={<IconCheck size={16} />} count={4}>Default MPill</MPill>
        <MPill icon={<IconCheck size={16} />} variant="filled" count={10}>Filled MPill</MPill>
      </div>
    </div>
  );
};

export default ChipDemo;
